<script>
  import { urlParams } from '../base/store'
  import { debounce } from '../base/utils'
// Props
  export let key, value, text
// Handlers
  const DELAY = 200
  const handle = debounce(DELAY, async e => {
    urlParams.toggleParam(key, value)
    await urlParams.applyFilters()
  })
  $: active = ($urlParams[key] || []).indexOf(value) > -1
</script>

<button on:click={handle} class:active={active}>
  {text}
</button>
